import {composeWithDevTools} from '@redux-devtools/extension'
import {
  applyMiddleware,
  combineReducers,
  legacy_createStore as createStore,
  ReducersMapObject
} from 'redux'
import {ThunkAction, ThunkDispatch, thunk as thunkMiddleware} from 'redux-thunk'
import errorReporterMiddleware from '../middleware/errorReporter'
import {AdultsActions} from './adults/adults.action'
import adultsReducer, {AdultState} from './adults/adults.reducer'
import authReducer from './authentication/authentication.reducer'
import {
  AuthenticationActionTypes,
  AuthState
} from './authentication/authentication.type'
import communitiesReducer from './communities/communities.reducer'
import {
  CommunitiesActionTypes,
  CommunitiesState
} from './communities/communities.type'
import forgotPasswordReducer from './forgot-password/forgot-password.reducer'
import {
  PasswordActionTypes,
  PasswordState
} from './forgot-password/forgot-password.type'
import learnersReducer from './learners/learners.reducer'
import {LearnerActionTypes, LearnerState} from './learners/learners.type'
import {MentorsActions} from './mentors/mentors.action'
import mentorsReducer, {MentorsState} from './mentors/mentors.reducer'
import resetPasswordReducer from './reset-password/reset-password.reducer'
import {
  ResetPasswordActionTypes,
  ResetPasswordState
} from './reset-password/reset-password.types'
import uiReducer from './ui/ui.reducer'
import {UIActionTypes, UIState} from './ui/ui.types'

export interface AppState {
  auth: AuthState
  communities: CommunitiesState
  adults: AdultState
  mentors: MentorsState
  ui: UIState
  forgotPassword: PasswordState
  resetPassword: ResetPasswordState
  learners: LearnerState
}

export type AppActions =
  | AuthenticationActionTypes
  | CommunitiesActionTypes
  | AdultsActions
  | MentorsActions
  | PasswordActionTypes
  | ResetPasswordActionTypes
  | UIActionTypes
  | LearnerActionTypes

export type AppThunkAction<Action extends AppActions> = ThunkAction<
  Promise<void>,
  AppState,
  undefined,
  Action
>

export type AppDispatch = ThunkDispatch<AppState, undefined, AppActions>

const reducers: ReducersMapObject<AppState, AppActions, AppState | undefined> =
  {
    auth: authReducer,
    communities: communitiesReducer,
    adults: adultsReducer,
    mentors: mentorsReducer,
    ui: uiReducer,
    forgotPassword: forgotPasswordReducer,
    resetPassword: resetPasswordReducer,
    learners: learnersReducer
  }

const rootReducer = combineReducers(reducers)

export default function configureStore(state?: AppState) {
  const middlewareEnhancer = applyMiddleware(
    thunkMiddleware,
    errorReporterMiddleware
  )
  const store = createStore(
    rootReducer,
    state,
    composeWithDevTools(middlewareEnhancer)
  )

  return store
}
